import api from '../utils/api';

const hrAdminService = {
  benefits: () => api.get('/api/hr/admin/benefits'),
  createBenefit: data => api.post('/api/hr/admin/benefits', data),
  disciplinaryActions: () => api.get('/api/hr/admin/disciplinary-actions'),
  createDisciplinaryAction: data => api.post('/api/hr/admin/disciplinary-actions', data),
  exits: () => api.get('/api/hr/admin/exits'),
  createExit: data => api.post('/api/hr/admin/exits', data),
  updateExit: (id, data) => api.patch(`/api/hr/admin/exits/${id}`, data),
  workforcePlans: () => api.get('/api/hr/admin/workforce-plans'),
  createWorkforcePlan: data => api.post('/api/hr/admin/workforce-plans', data),
  departments: () => api.get('/api/hr/admin/departments'),
  createDepartment: data => api.post('/api/hr/admin/departments', data),
  updateDepartment: (id, data) => api.patch(`/api/hr/admin/departments/${id}`, data),
  benefitPlans: () => api.get('/api/hr/admin/benefit-plans'),
  createBenefitPlan: data => api.post('/api/hr/admin/benefit-plans', data),
  updateBenefitPlan: (id, data) => api.patch(`/api/hr/admin/benefit-plans/${id}`, data),
  orgChart: () => api.get('/api/hr/admin/org-chart'),
  successionPlans: () => api.get('/api/hr/admin/succession-plans'),
  createSuccessionPlan: data => api.post('/api/hr/admin/succession-plans', data),
  updateSuccessionPlan: (id, data) => api.patch(`/api/hr/admin/succession-plans/${id}`, data),
};

export default hrAdminService;